import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
// import image from "../../images/ka3ba.jpg";

function PageLayout({ background = "default", children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    // You can add logic here if necessary
  }, [pathname]);

  return (
    <Box width="100vw" height="100%" minHeight="100vh" bgcolor={background} sx={{ overflowX: "hidden" }}>
      {children}
    </Box>
  );
}
PageLayout.propTypes = {
  background: PropTypes.oneOf(["white", "light", "default"]),
  children: PropTypes.node.isRequired,
};

function Footer() {
  return <Box position="absolute" width="100%" bottom={0} py={4}></Box>;
}
Footer.propTypes = { light: PropTypes.bool };

export default function AuthLayout({ children }) {
  return (
    <PageLayout>
      <section className="static-hero" >
      <Box px={1} width="100%" mx="auto"
          maxHeight="100vh"
          overflow="auto"
          sx={{
            "&::-webkit-scrollbar": {
              display: "none",
            },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}>
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={12} sm={10} md={7} lg={6} xl={5}>
                {children}
              </Grid>
        </Grid>
      </Box>
      <Footer light />
    </section>
    </PageLayout>
  );
}
AuthLayout.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
